import React, { useState } from "react";
import { FiEye, FiSearch } from "react-icons/fi";

export default function ProductsNeverPurchase() {
  const [filters, setFilters] = useState({
    category: "All",
    manufacturer: "All",
    vendor: "All",
    startDate: "",
    endDate: "",
  });

  const products = [
    "$100 Physical Gift Card",
    "$50 Physical Gift Card",
    "adidas Consortium Campus 80s Running Shoes",
    "Adobe Photoshop",
    "Apple iPhone 16 128GB",
    "Apple MacBook Pro",
    "Asus Laptop",
    "Beats Pill Wireless Speaker",
    "Build your own computer",
    "Custom T-Shirt",
    "Digital Storm VANQUISH Custom Performance PC",
    "Elegant Gemstone Necklace (rental)",
    "HP Envy 15.6-Inch Sleekbook",
    "HP Spectre XT Pro UltraBook",
    "HTC One Mini Blue",
  ];

  return (
    <div className="p-4 md:p-6 bg-gray-50 min-h-screen">
      <h1 className="text-xl font-semibold text-gray-800 mb-4">
        Products Never Purchased
      </h1>

      {/* Filters Section */}
      <div className="bg-white p-4 rounded-lg shadow-sm mb-6">
        <div className="flex items-center mb-4 gap-2">
          <FiSearch className="text-gray-500" />
          <span className="text-gray-700 font-medium">Search</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          <div>
            <label className="text-sm text-gray-600">Category</label>
            <select
              className="w-full border border-gray-300 rounded-md px-3 py-2"
              value={filters.category}
              onChange={(e) =>
                setFilters({ ...filters, category: e.target.value })
              }
            >
              <option>All</option>
              <option>Electronics</option>
              <option>Books</option>
              <option>Clothing</option>
            </select>
          </div>
          <div>
            <label className="text-sm text-gray-600">Manufacturer</label>
            <select
              className="w-full border border-gray-300 rounded-md px-3 py-2"
              value={filters.manufacturer}
              onChange={(e) =>
                setFilters({ ...filters, manufacturer: e.target.value })
              }
            >
              <option>All</option>
              <option>Apple</option>
              <option>HP</option>
              <option>Adidas</option>
            </select>
          </div>
          <div>
            <label className="text-sm text-gray-600">Vendor</label>
            <select
              className="w-full border border-gray-300 rounded-md px-3 py-2"
              value={filters.vendor}
              onChange={(e) =>
                setFilters({ ...filters, vendor: e.target.value })
              }
            >
              <option>All</option>
              <option>Vendor A</option>
              <option>Vendor B</option>
            </select>
          </div>
          <div>
            <label className="text-sm text-gray-600">Start date</label>
            <input
              type="date"
              className="w-full border border-gray-300 rounded-md px-3 py-2"
              value={filters.startDate}
              onChange={(e) =>
                setFilters({ ...filters, startDate: e.target.value })
              }
            />
          </div>
          <div>
            <label className="text-sm text-gray-600">End date</label>
            <input
              type="date"
              className="w-full border border-gray-300 rounded-md px-3 py-2"
              value={filters.endDate}
              onChange={(e) =>
                setFilters({ ...filters, endDate: e.target.value })
              }
            />
          </div>
        </div>

        <div className="mt-4">
          <button className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700">
            Run report
          </button>
        </div>
      </div>

      {/* Learn More */}
      <a
        href="#"
        className="text-blue-600 text-sm hover:underline mb-4 inline-block"
      >
        Learn more about reports
      </a>

      {/* Products Table */}
      <div className="overflow-x-auto bg-white rounded-lg shadow-sm">
        <table className="min-w-full text-sm text-left">
          <thead className="bg-gray-100 text-gray-700">
            <tr>
              <th className="py-3 px-4 font-medium">Name</th>
              <th className="py-3 px-4 font-medium text-center">View</th>
            </tr>
          </thead>
          <tbody>
            {products.map((product, i) => (
              <tr key={i} className="border-t hover:bg-gray-50">
                <td className="py-3 px-4">{product}</td>
                <td className="py-3 px-4 text-center">
                  <button className="flex items-center gap-1 bg-gray-100 hover:bg-gray-200 text-gray-700 text-sm px-3 py-1 rounded mx-auto">
                    <FiEye />
                    View
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="flex flex-col md:flex-row items-center justify-between mt-4 text-sm text-gray-600">
        <div className="flex items-center gap-2 mb-2 md:mb-0">
          <button className="px-3 py-1 border rounded hover:bg-gray-100">
            Previous
          </button>
          <span>1</span>
          <button className="px-3 py-1 border rounded hover:bg-gray-100">
            Next
          </button>
        </div>
        <div className="flex items-center gap-2">
          <span>Show</span>
          <select className="border border-gray-300 rounded-md px-2 py-1">
            <option>15</option>
            <option>30</option>
            <option>50</option>
          </select>
          <span>items</span>
        </div>
        <p>1–15 of 34 items</p>
      </div>
    </div>
  );
}
